import { Component } from '@angular/core';
import { BadgeColor, BadgeSize } from '../../../common-components/badge/badge.types';

@Component({
  selector: 'app-badge-playground',
  templateUrl: './badge-playground.component.html',
  styleUrls: ['./badge-playground.component.scss'],
})
export class BadgePlaygroundComponent {
  value: number = 12;
  size: BadgeSize = 'medium';
  color: BadgeColor = 'red';
  asString = false;

  readonly sizes: BadgeSize[] = ['small', 'medium', 'large'];
  readonly colors: BadgeColor[] = ['red', 'green', 'yellow', 'blue', 'neutral'];
}
